"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInputWithRef = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * This is a private text input component.  This is meant to be used
 * to build out other type of input components in the library.
 * (Select, Input, etc).
 */
var TextInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TextInput, _React$Component);

  function TextInput() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, TextInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TextInput)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.handleOnKeyDown = function (event) {
      var _this$props = _this.props,
          onKeyDown = _this$props.onKeyDown,
          onPressEnter = _this$props.onPressEnter;

      if (onKeyDown) {
        onKeyDown(event);
      }

      if (onPressEnter && event.key === 'Enter') {
        onPressEnter(event);
      }
    }, _temp));
  }

  _createClass(TextInput, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          inputRef = _this$props2.inputRef,
          error = _this$props2.error,
          onPressEnter = _this$props2.onPressEnter,
          onKeyDown = _this$props2.onKeyDown,
          disabled = _this$props2.disabled,
          appearance = _this$props2.appearance,
          prefix = _this$props2.prefix,
          suffix = _this$props2.suffix,
          addonBefore = _this$props2.addonBefore,
          addonAfter = _this$props2.addonAfter,
          inputProps = _objectWithoutProperties(_this$props2, ["className", "inputRef", "error", "onPressEnter", "onKeyDown", "disabled", "appearance", "prefix", "suffix", "addonBefore", "addonAfter"]);

      var styleProps = {
        'data-disabled': disabled,
        'data-type': appearance,
        'data-prefix': prefix,
        'data-addon-before': addonBefore,
        'data-suffix': suffix,
        'data-addon-after': addonAfter,
        'data-error': error
      };

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      return _react.default.createElement("input", _extends({
        type: "text",
        className: (0, _classnames.default)(className, "".concat(clsPrfx, " ").concat(clsPrfx, "-text-input")),
        ref: inputRef,
        disabled: disabled,
        onKeyDown: this.handleOnKeyDown
      }, styleProps, inputProps));
    }
  }]);

  return TextInput;
}(_react.default.Component);

exports.default = TextInput;
TextInput.defaultProps = {
  appearance: 'normal',
  disabled: false,
  prefix: false,
  suffix: false,
  addonBefore: false,
  addonAfter: false,
  error: false
};
TextInput.propTypes = {
  /**
   * Custom class name.
   */
  className: _propTypes.default.string,

  /**
   * This provides a way for you to get a reference to the <input> dom node.
   * It can be a call back function or an object from React.createRef().
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * To disable input set this to true
   */
  disabled: _propTypes.default.bool,

  /**
   * Input appearance style
   * 'inline' - Input is inline and nested with no borders or background.
   * 'normal' - border with focus highlight
   * 'borderless' - no border with focus highlight.  Normally used on darker contrasted background.
   * 'nested' - no border with no focus highlight.
   *    Useful around situation where you need input inside another component.
   *    For example input inside a table cell.
   */
  appearance: _propTypes.default.oneOf(['inline', 'normal', 'borderless', 'nested']),

  /**
   * Style the input to prepare for a prefix element.  See <InputAddOn>
   */
  prefix: _propTypes.default.bool,

  /**
   * Style the input to prepare for a suffix element.  See <InputAddOn>
   */
  suffix: _propTypes.default.bool,

  /**
   * Style the input to prepare for a addon element.  See <InputAddOn>
   */
  addonBefore: _propTypes.default.bool,

  /**
   * Style the input to prepare for a addon element.  See <InputAddOn>
   */
  addonAfter: _propTypes.default.bool,

  /**
   * Style the input to highlight error.
   */
  error: _propTypes.default.bool,

  /**
   * Callback when enter key is pressed
   */
  onPressEnter: _propTypes.default.func
};

var TextInputWithRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(TextInput, _extends({}, props, {
    inputRef: ref
  }));
});

exports.TextInputWithRef = TextInputWithRef;